import { useState } from 'react';
import { Box, Flex, HStack, Spinner, Text } from '@chakra-ui/react';
import { t } from 'i18next';
import StickyHeader from '../../components/StickyHeader';
import { ReactComponent as LikeShapeIcon } from '../../icons/like.shape.svg';
import { useQueryParams } from '@pocapan/shared/utils/useQueryParams';
import { Xmark } from '@peacecover/icon';
import { useHandleHistoryBack } from '@pocapan/shared/utils/useHandleHistoryBack';
import { ReportFootprintBreadcrumb } from '../../components/report/ReportFootprintBreadcrumb';
import { useMembersQuery } from '../../components/api/queries/useMemberQuery';
import StepComponent from '../../components/steps/StepComponent';

export const ReportSelectMemberPage = () => {
  const [selectedMember, setSelectedMember] = useState();
  const { queryParams, updateQueryParams } = useQueryParams();
  const reportType = queryParams.get('reportType');
  const locationId = queryParams.get('locationId');
  const artistId = queryParams.get('artistId');

  const { members, isLoading } = useMembersQuery(artistId);

  const handleHistoryBack = useHandleHistoryBack();

  const onSelectedMember = (member) => {
    const memberId = member.memberId;
    setSelectedMember(member);
    if (reportType === 'photoCard') {
      updateQueryParams({ memberId }, '/report-photo-card/event-activities');
    } else if (reportType === 'event') {
      updateQueryParams({ locationId, memberId }, '/report-location/spots');
    } else if (locationId && reportType === 'footprint') {
      updateQueryParams({ locationId, memberId }, '/report-location/footprints');
    }
  };

  const title = (() => {
    if (reportType === 'photoCard') {
      return t('ReportPhotoCardSelectMemberPage.titlePhotoCard');
    }
    if (reportType === 'event') {
      return t('ReportPhotoCardSelectMemberPage.titleEvent');
    }
    if (reportType === 'location' || reportType === 'footprint') {
      return t('ReportPhotoCardSelectMemberPage.titleLocation');
    }
    return t('ReportPhotoCardSelectMemberPage.title');
  })();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner />
      </div>
    );
  }

  return (
    <>
      <StickyHeader
        showBackButton={false}
        showTitle={true}
        alwaysShowTitle={true}
        title={
          reportType === 'event'
            ? t('ReportPhotoCardSelectMemberPage.pageName')
            : t('reportPhotoCardPage.pageName')
        }
        onClickBackButton={handleHistoryBack}
        leftContent={<Xmark size={24} className="text-text-main-lv1" onClick={handleHistoryBack} />}
      />
      <StepComponent currentStep={0} nextStep={1} maxStep={1} title="">
        <Flex
          flexDirection={'column'}
          paddingX={'24px'}
          paddingTop={'calc(55px + env(safe-area-inset-top))'}
          paddingBottom={'calc(48px + env(safe-area-inset-bottom))'}
        >
          <div className="flex flex-col gap-[18px] py-[10px]">
            <div className="mx-[-24px]">
              <ReportFootprintBreadcrumb />
            </div>
            <h1 className="text-[26px] font-bold text-pure-black dark:text-pure-white leading-none">
              {title}
            </h1>
          </div>
          <div className="flex flex-col gap-[16px] mt-[16px]">
            {members?.map((member) => {
              const isSelectedMember =
                selectedMember && selectedMember.memberId === member.memberId;
              return (
                <Box key={member.memberId}>
                  <HStack onClick={() => onSelectedMember(member)}>
                    <Text
                      fontSize={'40px'}
                      lineHeight={'48px'}
                      fontWeight={800}
                      className={
                        isSelectedMember
                          ? 'text-primary-light dark:text-primary-dark'
                          : 'text-disabled-light dark:text-disabled-dark'
                      }
                    >
                      {member.name}
                    </Text>
                    <LikeShapeIcon
                      className={
                        isSelectedMember
                          ? 'fill-primary-light dark:fill-primary-dark'
                          : 'fill-pure-white dark:fill-pure-black'
                      }
                      width={42}
                      height={42}
                      style={{ marginLeft: '3px' }}
                    />
                  </HStack>
                </Box>
              );
            })}
          </div>
          {reportType === 'event' && (
            <button
              type="button"
              className="flex items-center mt-[36px] mx-auto"
              onClick={() => {
                const namesCsv = (members || []).map((m) => m.memberId).join(',');
                updateQueryParams({ memberId: namesCsv }, '/report-location/spots');
              }}
            >
              <p className="text-[14px] font-medium text-text-main-lv4 leading-none">
                {t('ReportPhotoCardSelectMemberPage.selectAllMembers')}
              </p>
            </button>
          )}
        </Flex>
      </StepComponent>
    </>
  );
};
